import * as Yup from "yup";

export const ArtistTermsSchemaFragment = {
  confirm_no_copyright: Yup.bool().oneOf(
    [true],
    "signup-details-accordion-form-error-checkbox"
  ),
  confirm_ownership: Yup.bool().oneOf(
    [true],
    "signup-details-accordion-form-error-checkbox"
  ),
  confirm_listening_rights: Yup.bool().oneOf(
    [true],
    "signup-details-accordion-form-error-checkbox"
  ),
};
